import { EventBus } from '../utils/eventBus';
import { TabsService } from '../services/tabs';
import { ThemeService } from '../services/theme';
import { ThemeToggle } from './ThemeToggle';
import { createButton, clearElement } from '../utils/dom';

export class Toolbar {
  private container: HTMLElement | null = null;
  private themeToggle: ThemeToggle;

  constructor(
    private eventBus: EventBus,
    private tabsService: TabsService,
    private themeService: ThemeService
  ) {
    this.themeToggle = new ThemeToggle(eventBus, themeService);
  }

  mount(container: HTMLElement): void {
    this.container = container;
    this.render();
  }

  private render(): void {
    if (!this.container) return;

    clearElement(this.container);

    // Upload image button
    const uploadButton = createButton('📎', 'btn btn-icon', () => {
      this.eventBus.emit('toolbar:uploadImage');
    });
    uploadButton.title = 'Upload image';
    this.container.appendChild(uploadButton);

    // Open gallery button
    const galleryButton = createButton('🖼️', 'btn btn-icon', () => {
      this.eventBus.emit('toolbar:openGallery');
    });
    galleryButton.title = 'Open image gallery';
    this.container.appendChild(galleryButton);

    // Reset context button (as emoji, placed in chat operators area)
    const resetButton = createButton('🔄', 'btn btn-icon', () => {
      if (confirm('Reset current conversation? This will clear all messages.')) {
        this.tabsService.resetActiveTab();
      }
    });
    resetButton.title = 'Reset conversation';
    this.container.appendChild(resetButton);

    // Theme toggle
    this.themeToggle.mount(this.container);
  }

  destroy(): void {
    this.themeToggle.destroy();
  }
}
